import React from "react";
import { MenuSection } from "../../Components/MenuSection";
import { Layout } from "../../Components/Layout";

export const Menu = () => {
	return (
		<Layout>
			<MenuSection />
		</Layout>
	);
};
